import { httpsCallable } from 'firebase/functions';
import { functions } from '../../constants/firebaseModular';
import type { GetAppleWalletPassPayload, GetAppleWalletPassResponse } from '@usacsmideo/types';
import * as Sentry from '@sentry/browser';

export const getAppleWalletPass = async (patientId: string): Promise<GetAppleWalletPassResponse> => {
  const callable = httpsCallable<GetAppleWalletPassPayload, GetAppleWalletPassResponse>(
    functions,
    'getAppleWalletPass',
  );
  try {
    const result = await callable({ patientId });
    return result.data;
  } catch (error: unknown) {
    Sentry.captureException(error, { tags: { function: 'getAppleWalletPass' } });
    throw error;
  }
};
